import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

import { AppConfigModel } from '@libs/cms/models';

import { LekkerlandHeaderComponent } from '../lekkerland-header';
import { LekkerlandMobileNavigationComponent } from '../lekkerland-mobile-navigation';
import { SideSheetDirective } from '../../overlays/sidesheet';

@Component({
  selector: 'ui-lekkerland-header-slot',
  templateUrl: './lekkerland-header-slot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LekkerlandHeaderComponent,
    LekkerlandMobileNavigationComponent,
    SideSheetDirective,
  ],
  standalone: true,
})
export class LekkerlandHeaderSlotComponent {
  public readonly config: InputSignal<AppConfigModel> = input.required();
}
